var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import i18n from '@/i18n';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
let AColorPicker = class AColorPicker extends Vue {
    constructor() {
        super(...arguments);
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.selectedColor = '#F9A825';
        this.isLoading = true;
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks
    mounted() {
        this.initialize();
    }
    async initialize() {
        this.isLoading = true;
        if (!this.value) {
            this.$emit('input', this.selectedColor);
        }
        this.isLoading = false;
    }
    // #endregion
    // #region Event handlers
    onSelectedColorChange() {
        this.$emit('input', this.selectedColor);
    }
    // #endregion
    // #region Class methods
    // #endregion
    // #region Async methods (api calls only)
    // #endregion
    // #region Getters & Setters
    // #endregion
    // #region @Watchers
    onValueChange(newValue) {
        if (newValue) {
            this.selectedColor = newValue;
        }
    }
};
__decorate([
    Prop({ default: i18n.tc('curriculum.newSubject.select.areaColor') }),
    __metadata("design:type", String)
], AColorPicker.prototype, "label", void 0);
__decorate([
    Prop({ default: '' }),
    __metadata("design:type", String)
], AColorPicker.prototype, "value", void 0);
__decorate([
    Watch('value', { immediate: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AColorPicker.prototype, "onValueChange", null);
AColorPicker = __decorate([
    Component({})
], AColorPicker);
export default AColorPicker;
// #region Enums
// #endregion
// #region Interfaces
// #endregion
// #region Constants
// #endregion
